import { THeaderType } from 'components/Header/Header'
import React, { FC } from 'react'
import { DropdownType } from 'src/types'
import styled from 'styled-components'
import NavUl from 'ui/NavUl'
import getHeaderNavbarData from 'utils/getHeaderNavbarData'
import DropdownBuyCrypto from '../DropdownBuyCrypto'
import DropdownContainer from '../DropdownContainer'
import { DropdownCopytrading } from '../DropdownCopytrading'
import DropdownExploreTrading from '../DropdownExploreTrading'
import DropdownFutures from '../DropdownFutures/DropdownFutures'
import DropdownPriceAlerts from '../DropdownPriceAlerts'
import DropdownSpot from '../DropdownSpot'
import DropdownStaking from '../DropdownStaking'

const handleDropdown = (dropdownType: DropdownType | string, type: THeaderType) => {
  switch (dropdownType) {
    case 'buy crypto':
      return <DropdownBuyCrypto dropdownType={dropdownType} options={[]} type={type} />
    case 'futures':
      return <DropdownFutures dropdownType={dropdownType} options={[]} type={type} />
    case 'spot':
      return <DropdownSpot dropdownType={dropdownType} options={[]} type={type} />
    case 'explore trading':
      return <DropdownExploreTrading dropdownType={dropdownType} options={[]} type={type} />
    case 'price alerts':
      return <DropdownPriceAlerts dropdownType={dropdownType} options={[]} type={type} />
    case 'staking':
      return <DropdownStaking dropdownType={dropdownType} options={[]} type={type} />
    case 'copy trading':
      return <DropdownCopytrading />
    default:
      return undefined
  }
}

const NavBar: FC<Props> = ({ type }) => {
  const navbar = getHeaderNavbarData()

  return (
    <Container>
      <Ul>
        {navbar?.map((link, id) => {
          return (
            <Li key={id}>
              {link && (
                <DropdownContainer
                  dropdownType={link.type}
                  type={type}
                  name={link.name}
                  linkIcon={link.linkIcon}
                  dropdown={link.dropdown}>
                  {handleDropdown(link.type, type)}
                </DropdownContainer>
              )}
            </Li>
          )
        })}
      </Ul>
    </Container>
  )
}

const Container = styled.div`
  display: none;
  @media ${({ theme }) => theme.device.lg} {
    display: flex;
  }
`

const Ul = styled(NavUl)`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  margin-inline-end: 12px;
`

const Li = styled.li`
  position: relative;
  cursor: pointer;
  padding: 0 1rem;
  padding-right: 0;
  padding-inline-start: 0;
  @media ${({ theme }) => theme.device.lg} {
    padding: 0;
    text-align: right;
  }
  &:first-child {
    padding-inline-start: 0;
  }
`

interface Props {
  type: THeaderType
}

export default NavBar
